import { render, staticRenderFns } from "./ValorRecebido.vue?vue&type=template&id=d5458686&scoped=true&"
import script from "./ValorRecebido.vue?vue&type=script&lang=js&"
export * from "./ValorRecebido.vue?vue&type=script&lang=js&"
import style0 from "./ValorRecebido.vue?vue&type=style&index=0&id=d5458686&scoped=true&lang=css&"
import style1 from "./ValorRecebido.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5458686",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
